<span class="perk-label capitalize">
  @if (perk.custom) {
    <span [ghs-label]="perk.custom"></span>
    @if (perk.type !== PerkType.custom) {
      <span class="spacing" [ghs-label]="'and'"></span>
    }
  }
  @if (perk.type !== PerkType.custom) {
    <span class="label" [ghs-label]="'game.attackModifiers.perks.type.' + perk.type" [ghs-label-args]="perkLabel"></span>
  }
  @if (perk.monsterDeck) {
    <span class="spacing" [ghs-label]="'game.attackModifiers.perks.monsterDeck'"></span>
  }
</span>
